import { render, staticRenderFns } from "./ManageUsersPage.vue?vue&type=template&id=2b427b78&scoped=true&"
import script from "./ManageUsersPage.vue?vue&type=script&lang=js&"
export * from "./ManageUsersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b427b78",
  null
  
)

export default component.exports